module.exports = __webpack_public_path__ + "img/merchpage_main.062bb97e.png";